import { RG_TYPE } from "@project-rouge/rg-core";
import { getRatios } from "./index122.js";
function getDistribution(sequence, props) {
  const unitMix = props.targetUnitMix;
  const counter = unitMix.map((m) => {
    return { label: m.label, count: 0 };
  });
  let apartment;
  for (const action of sequence) {
    if (action.unit.type === RG_TYPE.Entrance) {
      apartment = props.dataset.apartments.aboveEntrance[0];
    }
    if (action.unit.type === RG_TYPE.Apartment) {
      apartment = action.unit;
    }
    if (apartment) {
      counter.find((c) => c.label === apartment.data.category).count++;
    }
  }
  const ratios = getRatios(counter.map((m) => m.count));
  return ratios;
}
export {
  getDistribution
};
//# sourceMappingURL=index244.js.map
